import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { ApiResponse } from './../systemTransfer/systemTransfer.types';
import { PermissionsResponse } from './permissionsApi.types';

const getPermissionsByRole = (client: AxiosInstance) => async (roleId: string) => {
  return (await client.get<ApiResponse<PermissionsResponse>>('/get-role-permissions', { params: { roleId } })).data;
};

export const permissionQueries = {
  all: () => ['users'],
  permissions: (roleId: string, enabled: boolean) =>
    queryFactoryOptions({
      queryKey: [...permissionQueries.all(), 'permissions', roleId],
      queryFn: (client: AxiosInstance) => () => getPermissionsByRole(client)(roleId),
      enabled,
    }),
};
